// Generated by `yarn tokens:import --aos-ds` from the Figma component set "Widget/Punctuality/ChartTooltip/FlightRow" (19022:458356). Do not edit.

import type { FigmaGlyph } from '../../icons/glyph'

export type ContractProp =
    | { kind: 'enum'; values: readonly string[] }
    | { kind: 'boolean' }
    | { kind: 'text' }
    | { kind: 'instance_swap' }
    // A matrix can carry slots too — Modal/Footer has two.
    | { kind: 'slot' }

export type ContractComposition = { component: string; variants: readonly string[] }

// A place the Figma file contradicts itself, grouped by what it says. `count` is
// how many places say it; `property` and `stated` are set for an alignment the
// file states and does not draw.
export type ContractDisagreement = {
    note: string
    count: number
    property?: string
    stated?: string
}

export type ContractVariant = {
    container: string
    label: string
    // The surface, when the paint sits on a child rather than the root:
    // empty for every component that paints its own frame.
    box: string
    // Every named node the variant draws beyond those two, keyed by the
    // name Figma gives it. A key that reads as a value rather than a role
    // means the component is a composition, not a primitive.
    parts: Record<string, string>
    // The shape of every part that is one — a VECTOR drawn on top of
    // something the variant also paints, which the whole-variant `glyph`
    // cannot describe because that one requires no paint at all.
    glyphs: Record<string, FigmaGlyph>
    // The glyph the variant draws, inked separately from the label.
    icon: string
    // Applied in JS: `disabled:` never matches a react-native-web div, and
    // `:visited` exists only on an anchor.
    disabled: string
    visited: string
    // Which of `textStyleIds` each text part is set in. The ids are a set,
    // so a component with two says two exist and not which part uses which.
    partTextStyles: Record<string, string>
    // What this cell instantiates, and which variant of it.
    composes: readonly ContractComposition[]
}

export const widgetPunctualityCharttooltipFlightrowContract = {
    component: 'Widget/Punctuality/ChartTooltip/FlightRow',
    nodeId: '19022:458356',
    section: 'Punctuality · Components',
    composes: [] as readonly ContractComposition[],
    stateAxis: null,
    // Where the caller puts content. One `ReactNode` prop per name.
    slots: [] as readonly string[],
    // What the file says that its own drawing does not show.
    disagreeing: [
        { note: '3 labels with their own ink or style', count: 1 },
        {
            note: 'textAlignHorizontal RIGHT on a HUG text — renders left, so the file states an alignment it does not draw',
            count: 1,
            property: 'textAlignHorizontal',
            stated: 'RIGHT',
        },
    ] as readonly ContractDisagreement[],
    textStyleIds: ['S:0fa036ddc0a173a340137517ff39c483dfbade3d,'],
    props: {
        codes: { kind: 'text' },
        delay: { kind: 'text' },
        flight: { kind: 'text' },
        user: { kind: 'enum', values: ['finavia', 'external'] },
    },
    variants: {
        'user=external': {
            container: 'gap-s w-[16.5rem] items-start',
            label: 'text-content-default text-left',
            icon: '',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                flight: 'text-content-default text-left w-[4rem]',
                delay: 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                flight: 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
                delay: 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [],
        },
        'user=finavia': {
            container: 'gap-s w-[16.5rem] items-start',
            label: 'text-content-default text-left',
            icon: '',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                flight: 'text-content-default text-left w-[4rem]',
                delay: 'text-content-default text-left',
                codes: 'text-content-muted text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                flight: 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
                delay: 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
                codes: 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [],
        },
    },
} as const satisfies {
    component: string
    nodeId: string
    section: string
    composes: readonly ContractComposition[]
    stateAxis: string | null
    slots: readonly string[]
    disagreeing: readonly ContractDisagreement[]
    textStyleIds: readonly string[]
    props: Record<string, ContractProp>
    variants: Record<string, ContractVariant>
}
